import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Services", href: "#services" },
  { label: "Why Us", href: "#about" },
  { label: "Reviews", href: "#testimonials" },
  { label: "Contact", href: "#contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 w-full z-50 transition-all duration-300 backdrop-blur-xl border-b ${
        scrolled ? "bg-white/85 border-slate-200" : "bg-white/40 border-transparent"
      }`}
    >
      <nav className="container mx-auto px-6 sm:px-8 flex items-center justify-between h-20">
        <a href="#top" data-testid="logo-link" className="flex items-center gap-3 group">
          <img
            src="https://customer-assets.emergentagent.com/job_zid-services-portal/artifacts/3obxc0re_logo-transparent-png.webp"
            alt="ZID IT Solutions logo"
            className="h-12 w-auto object-contain"
          />
          <span className="font-heading font-black text-xl tracking-tighter text-slate-950 hidden sm:block">
            ZID <span className="text-blue-600">IT</span> Solutions
          </span>
        </a>

        <div className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(" ", "-")}`}
              className="text-sm font-medium text-slate-600 hover:text-blue-600 transition-colors"
            >
              {l.label}
            </a>
          ))}
        </div>

        <a
          href="#contact"
          data-testid="nav-quote-btn"
          className="hidden md:inline-flex items-center bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold px-6 py-3 transition-colors"
        >
          Get a Quote
        </a>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-slate-950"
          onClick={() => setOpen(!open)}
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden bg-white border-t border-slate-200 px-6 py-6 flex flex-col gap-4">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-${l.label.toLowerCase().replace(" ", "-")}`}
              className="text-base font-medium text-slate-700"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            data-testid="mobile-nav-quote-btn"
            className="bg-blue-600 text-white text-center font-semibold px-6 py-3 mt-2"
          >
            Get a Quote
          </a>
        </div>
      )}
    </header>
  );
};
